export default "__VITE_ASSET__$NW8ac6b__"